// 优先级
export const taskLevelMap = [
  {
    key: 4,
    name: '最高',
    otherName: '高',
    color: '#FF3939',
    bgColor: '#FFE0E0',
    fliter: ['#FFD8DA', '#FFB0B3'],
    icon: '#E74C62',
    childrenBackcolor: '#FFEEEF',
    childrenBorder: '#FF8186'
  },
  {
    key: 3,
    name: '中等',
    otherName: '中',
    color: '#FF8B23',
    bgColor: '#FFF1E4',
    fliter: ['#FFEFC2', '#FFDA8F'],
    icon: '#FFA331',
    childrenBackcolor: '#FFF7E0',
    childrenBorder: '#FFC03F'
  },
  {
    key: 2,
    name: '普通',
    otherName: '普',
    color: '#509AFF',
    bgColor: '#E6F1FF',
    fliter: ['#C4DFFF', '#A3CAFE'],
    icon: '#3D86EB',
    childrenBackcolor: '#EBF4FF',
    childrenBorder: '#7CB4FF'
  },
  {
    key: 1,
    name: '低',
    otherName: '低',
    color: 'rgba(32, 32, 32, 0.6)',
    bgColor: '#EEEEEE',
    fliter: ['#DADBE0', '#CFD0D6'],
    icon: '#75748E',
    childrenBackcolor: '#F0F1F6',
    childrenBorder: '#A6A6B6'
  }
]

// 优先级对象标示 { 9: "多旋翼", 8:"直升机"}
export const taskLevelKeyValue = taskLevelMap.reduce((total, item) => {
  total[item.key] = item.name;
  return total;
}, {});

export const taskLevelKeyOtherValue = taskLevelMap.reduce((total, item) => {
  total[item.key] = item.otherName;
  return total;
}, {});

// 完成状态
export const taskStatusMap = [

  {
    key: 2,
    name: "已完成",
    color: "#00B97E",
    bgColor: "rgba(0,185,126,0.10)"
  },
  {
    key: 1,
    name: "未完成",
    color: "#FFA350",
    bgColor: "rgba(255,163,80,0.20)"
  }
];
export const taskStatusKeyValue = taskStatusMap.reduce((total, item) => {
  total[item.key] = item.name;
  return total;
}, {});


// 日志动作描述
export const messageLogActoin = [
  {
    type: 1,
    action: "add_task",
    describe: "新建任务"
  },
  {
    type: 1,
    action: "delete_task",
    describe: "删除任务"
  },
  {
    type: 2,
    action: "update_task_title",
    describe: "更新任务标题"
  },
  {
    type: 2,
    action: "update_task_content",
    describe: "更新任务描述"
  },
  {
    type: 2,
    action: "update_task_principal",
    describe: "更新任务负责人"
  },
  {
    type: 2,
    action: "update_task_endtime",
    describe: "更新任务截止时间"
  },
  {
    type: 2,
    action: "update_task_status",
    describe: "更新任务状态"
  },
  {
    type: 2,
    action: "update_task_type",
    describe: "更新任务优先级"
  },
  {
    type: 2,
    action: "add_task_members",
    describe: "添加任务参与人"
  },
  {
    type: 2,
    action: "delete_task_members",
    describe: "删除任务参与人"
  },
  {
    type: 2,
    action: "task_comment",
    describe: "评论任务"
  }
];
export const messageLogActoinMap = messageLogActoin.reduce((total, item) => {
  total[item.action] = item.describe;
  return total;
}, {});
